import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BlogPost from './BlogPost';
import { updatePageSEO, generateBlogPostStructuredData } from '../../utils/seo-helpers';

export default function DynamicBlogPost() {
    const { slug } = useParams();
    const [blogPost, setBlogPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlogPost = async () => {
            if (!slug) return;
            
            try {
                setLoading(true);
                
                // Fetch from API (markdown files will be available after webhook creates them)
                const response = await fetch(`/api/blog-posts/${slug}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const post = await response.json();
                setBlogPost(post);
                
                // Update SEO for this blog post
                updatePageSEO({
                    title: post.title,
                    description: post.metaDescription || post.subtitle || `Read ${post.title} on the Honeybear.ai blog`,
                    keywords: post.tags ? post.tags.join(', ') : '',
                    canonical: `https://www.honeybear.ai/blog/${post.slug}`,
                    ogImage: post.featuredImage || 'https://www.honeybear.ai/Official_Logo_Honeybear.jpg',
                    ogType: 'article',
                    structuredData: generateBlogPostStructuredData(post)
                });
                
            } catch (err) {
                setError(err.message);
                setBlogPost(null);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogPost();
    }, [slug]);

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '50vh',
                fontSize: '18px'
            }}>
                Loading blog post...
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '50vh',
                fontSize: '18px',
                color: 'red'
            }}>
                Blog post not found
            </div>
        );
    }

    if (!blogPost) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '50vh',
                fontSize: '18px'
            }}>
                Blog post not found
            </div>
        );
    }

    return <BlogPost {...blogPost} />;
} 